// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"updated-topics-view_shadow__2zPiS","heading":"updated-topics-view_heading__1fxOg"};